import Menu from './components/Menus';
import Slider from './components/Slider';
import Gallery from './components/Gallery';

const menuButton = document.querySelector('.menu-button');
if (menuButton) {
    new Menu();
}

Slider();
Gallery();